import React, { useMemo } from "react";
// import blogimage1 from '../../assets/blogimage1.png';
import blogimage2 from "../../assets/blogimage2.png";
import blogimage3 from "../../assets/blogimage3.png";
import zynthtext from "../../assets/zynth-text.png";
import Blogimage1 from "../../assets/Blogimage1.avif";
import Blogimage2 from "../../assets/Blogimage2.avif";
import Blogimage3 from "../../assets/Blogimage3.avif";
import Blogimage4 from "../../assets/Blogimage4.avif";
import Blogimage6 from "../../assets/Blogimage6.avif";
import Blogimage7 from "../../assets/Blogimage7.avif";
import Blogimage8 from "../../assets/Blogimage8.avif";
import Blogimage9 from "../../assets/Blogimage9.avif";
import Blogimage10 from "../../assets/Blogimage10.avif";
import Blogimage11 from "../../assets/Blog10-image1.jpg";
import Blogimage12 from "../../assets/Blog11-image1.jpg";
import Blogimage13 from "../../assets/Blog13-image1.jpg";
import Blogimage14 from "../../assets/Blog14-image1.png";
import Blogimage15 from "../../assets/Blog15_image1.jpg";
import Blogimage16 from "../../assets/Blog16-image1.jpg";
import Blogimage17 from "../../assets/image1 b7.jpg";
import Blogimage18 from "../../assets/image1 b8.jpg";
import Blogimage19 from "../../assets/image1 b9.png";
import Blogimage20 from "../../assets/20th blog images/image1.jpg";
import Blogimage21 from "../../assets/21st blog images/image1.jpg";
import Blogimage22 from "../../assets/22nd blog images/image1.jpg";
import Blogimage23 from "../../assets/23rd blog images/image 1.jpg";
import Blogimage24 from "../../assets/24th blog images/image 1.jpg";
import Blogimage25 from "../../assets/25th blog images/image 1.jpg";
import Blogimage26 from "../../assets/26th blog images/image 1.jpg";
import Blogimage27 from "../../assets/27th blog images/image 1.jpg";
import Blogimage28 from "../../assets/28th blog images/image 1.jpg";
import Blogimage29 from "../../assets/29th blog images/image 1.jpg";
import Blogimage30 from "../../assets/30th blog images/image 1.jpg";
import Blogimage31 from "../../assets/31st blog images/image 1.jpg";
import Blogimage32 from "../../assets/images blog 32/images blog 32/bl32_image 1.png";
import Blogimage33 from "../../assets/images blog 33/image 1.png";
import Blogimage34 from "../../assets/images blog 34/images blog 34/image 1.png";
import Blogimage35 from "../../assets/images blog 35/images blog 35/image 1.png";
import Blogimage36 from "../../assets/images blog 36/images blog 36/image 1.png";
import Blogimage37 from "../../assets/images BLOG 37/image 1.png";
import Blogimage38 from "../../assets/Blog38image 1 (1).png";
import Blogimage39 from "../../assets/Blog39_image 1 (1).png";
import Blogimage40 from "../../assets/Blog40_image 1 (1).jpg";
import Blogimage41 from "../../assets/Blog41_image 1 (1).jpg";
import Blogimage42 from "../../assets/Blog42_image1.jpg";



import { useNavigate } from "react-router-dom";

interface Blog {
  id: number;
  date: string;
  readTime: string;
  title: string;
  description: string;
  views: number;
  comments: number;
  imageUrl: string;
  route: string;
}

const blogData: Blog[] = [
  {
    id: 1,
    date: "Mar 17,2024",
    readTime: "6 min read",
    title: "Unlocking the Journey of a Presentation: From Research to Impact",
    description:
      "Why Do Some Presentations Win Deals While Others Get Ignored? Think about the last business presentation you had to prepare. How many...",
    views: 8,
    comments: 0,
    imageUrl: Blogimage1,
    route: "unlocking-the-journey-of-a-presentation-from-research-to-impact",
  },
  {
    id: 2,
    date: "Mar 17,2024",
    readTime: "3 min read",
    title:
      "Struggling to Create the Perfect Sales Deck? Zynth's AI Can Do It in Minutes!",
    description:
      "If you're here, you're struggling to create a sales deck that wins deals and impresses clients. You're not alone — business owners, sales...",
    views: 8,
    comments: 0,
    imageUrl: Blogimage2,
    route:
      "struggling-to-create-the-perfect-sales-deck-zynths-ai-can-do-it-in-minutes",
  },
  {
    id: 3,
    date: "Feb 14,2024",
    readTime: "7 min read",
    title: "Scaling Smart: How AI is Redefining Presentation Creation",
    description:
      "The Burden of Repetitive Presentations Creating presentations is no longer a one-time task – it's an ongoing process. Whether it's...",
    views: 17,
    comments: 0,
    imageUrl: Blogimage3,
    route: "scaling-smart-how-ai-is-redefining-presentation-creation",
  },
  {
    id: 4,
    date: "Jan 9,2024",
    readTime: "4 min read",
    title: "The Hidden Cost of Business Presentations and How to Solve It",
    description:
      "Every day, over 30 million PowerPoint presentations  are delivered globally, yet many fail to make the desired impact. Business...",
    views: 8,
    comments: 0,
    imageUrl: Blogimage4,
    route: "the-hidden-cost-of-business-presentations-and-how-to-solve-it",
  },
  {
    id: 5,
    date: "Oct 24,2024",
    readTime: "8 min read",
    title:
      "Pitching to Impact Investors: Strategies for Communicating Social and Environmental Impact",
    description:
      "What is Impact Investing? Impact investing involves making investments with the dual purpose of generating positive, measurable social...",
    views: 46,
    comments: 0,
    imageUrl: blogimage2,
    route:
      "pitching-to-impact-investors-strategies-for-communicating-social-and-environmental-impact",
  },
  {
    id: 6,
    date: "May 17,2024",
    readTime: "8 min read",
    title:
      "The Metrics Marathon: Choosing the Right Data Points for Your Startup Pitch Deck",
    description:
      "Why Metrics Matters? Metrics serve as the language of business, facilitating communication between founders and investors. When pitching...",
    views: 8,
    comments: 0,
    imageUrl: Blogimage6,
    route:
      "the-metrics-marathon-choosing-the-right-data-points-for-your-startup-pitch-deck",
  },
  {
    id: 7,
    date: "Apr 8,2024",
    readTime: "11 min read",
    title: "The Investor's Perspective: What They Look for in a Pitch Deck",
    description:
      "Creating a killer pitch deck is super important when you're trying to get investors on board. It's not just about making pretty slides;...",
    views: 116,
    comments: 0,
    imageUrl: Blogimage7,
    route: "the-investors-perspective-what-they-look-for-in-a-pitch-deck",
  },
  {
    id: 8,
    date: "Mar 5,2024",
    readTime: "9 min read",
    title:
      "AI-Powered Digital Transformation: The Competitive Edge for Tech Companies",
    description:
      "In the age of digital evolution, businesses face a dual challenge: the imperative to innovate and the necessity to remain agile amidst...",
    views: 45,
    comments: 0,
    imageUrl: Blogimage8,
    route:
      "ai-powered-digital-transformation-the-competitive-edge-for-tech-companies",
  },
  {
    id: 9,
    date: "Jan 23,2024",
    readTime: "7 min read",
    title: "From DIY to AI: The Evolution of Pitch Deck Creation",
    description:
      "The Pitch Deck A humble collection of slides holding the potential to make or break your startup's future. In the early days, crafting a...",
    views: 156,
    comments: 0,
    imageUrl: Blogimage9,
    route: "from-diy-to-ai-the-evolution-of-pitch-deck-creation",
  },
  {
    id: 10,
    date: "Jan 18,2022",
    readTime: "7 min read",
    title: "Building blocks of a prefect pitch deck",
    description:
      "Over the past few years, there has been a lot of conversation around pitch decks. It has become an integral part of starting up and...",
    views: 180,
    comments: 1,
    imageUrl: Blogimage10,
    route: "building-blocks-of-a-prefect-pitch-deck",
  },
  {
    id: 11,
    date: "Aug 18,2025",
    readTime: "5 min read",
    title: "From Manual Slides to AI-Powered Decks",
    description:
      "An AI-powered presentation deck is not just a slide—it’s an intelligent communication system. Instead of manually formatting text,...",
    views: 180,
    comments: 1,
    imageUrl: Blogimage11,
    route: "from-manual-slides-to-ai-powered-decks",
  },
  {
    id: 12,
    date: "Aug 20,2025",
    readTime: "6 min read",
    title:
      "Inside Zynth.ai: How Our Presentation Engine Works Behind the Scenes",
    description:
      "In today’s fast-paced business environment, presentations aren’t just about design—they’re about clarity, speed, and impact. Leaders,...",
    views: 180,
    comments: 1,
    imageUrl: Blogimage12,
    route: "inside-zynth-ai",
  },
  {
    id: 13,
    date: "Aug 22,2025",
    readTime: "6 min read",
    title:
      "Introducing the Zynth Google Slides Add-On: Generate Decks Inside Your Workflow",
    description:
      "In today’s business environment, speed, clarity, and creativity define success. Whether it’s pitching to investors...",
    views: 180,
    comments: 1,
    imageUrl: Blogimage13,
    route: "introducing-the-zynth-google-slides-add-on",
  },
  {
    id: 14,
    date: "Aug 25,2025",
    readTime: "6 min read",
    title:
      "Powering Presentation Generation for Developers & Platforms",
    description:
      "In today’s digital-first business landscape, presentations are more than just slides—they are decision-making tools...",
    views: 180,
    comments: 1,
    imageUrl: Blogimage14,
    route: "zynth-api-powering-presentation-generation-for-developers-and-platforms",
  },
  {
    id: 15,
    date: "Aug 27,2025",
    readTime: "6 min read",
    title:
      "Why AI Will Replace Templates in Presentation Building: The Future of Slide Creation",
    description:
      "From classrooms to boardrooms, PowerPoint presentations have been the language of ideas for decades....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage15,
    route: "why-ai-will-replace-templates-in-presentation-building-the-future-of-slide-creation",
  },
  {
    id: 16,
    date: "Aug 29,2025",
    readTime: "6 min read",
    title:
      "How to Instantly Generate Branded Presentations Without a Designer",
    description:
      "In every industry, communication is the backbone of success. Whether you’re pitching to investors,....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage16,
    route: "how-to-instantly-generate-branded-presentations-without-a-designer",
  },
   {
    id: 17,
    date: "Sep 1,2025",
    readTime: "6 min read",
    title:
      "From Startup Pitches to Corporate Reports: Top Use Cases for Zynth.ai",
    description:
      "Whether you are a startup founder meeting investors, a consultant pitching a strategy, or ....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage17,
    route: "from-startup-pitches-to-corporate-reports-top-use-cases-for-zynth-ai",
  },
  {
    id: 18,
    date: "Sep 3,2025",
    readTime: "6 min read",
    title:
      "How to Turn Text Into Google Slides Instantly (No Design Skills Required)",
    description:
      "Creating a presentation used to mean hours of formatting, tweaking fonts, aligning text boxes....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage18,
    route: "how-to-turn-text-into-google-slides-instantly-no-design-skills-required",
  },
  {
    id: 19,
    date: "Sep 4,2025",
    readTime: "6 min read",
    title:
      "How to Build Custom Presentation Tools on Top of Zynth’s API",
    description:
      "The world of PowerPoint presentations and Google presentation software has changed dramatically....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage19,
    route: "how-to-build-custom-presentation-tools-on-top-of-zynths-api",
  },
  {
    id: 20,
    date: "Sep 8,2025",
    readTime: "6 min read",
    title:
      "APIs as the Backbone of the Next-Gen Productivity Tools",
    description:
      "In today’s business world, speed, connectivity, and automation define success. Teams no longer rely on....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage20,
    route: "apis-as-the-backbone-of-the-next-gen-productivity-tools",
  },
  {
    id: 21,
    date: "Sep 10,2025",
    readTime: "6 min read",
    title:
      "10 Common Presentation Mistakes (and How AI Can Fix Them)",
    description:
      "From startup pitch decks to enterprise boardroom reviews, PowerPoint presentations remain....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage21,
    route: "10-common-presentation-mistakes-and-how-ai-can-fix-them",
  },
  {
    id: 22,
    date: "Sep 12,2025",
    readTime: "6 min read",
    title:
      "Scaling Content Production With Zynth: A Guide for Agencies & SMEs",
    description:
      "In today’s business landscape, content isn’t optional—it’s the fuel for growth....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage22,
    route: "scaling-content-production-with-zynth-a-guide-for-agencies-and-smes",
  },
  {
  id: 23,
  date: "Sep 15,2025",
  readTime: "6 min read",
  title: "Step-by-Step: Installing & Using Zynth's Google Slides Add-On",
  description:
    "In the world of business communication, PowerPoint presentations and Google Slides deck....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage23,
  route: "step-by-step-installing-and-using-zynths-google-slides-add-on",
},
{
  id: 24,
  date: "Sep 17,2025",
  readTime: "6 min read",
  title: "Automating Business Reporting With the Zynth API",
  description:
    "Every business—whether a fast-moving startup, a scaling SME, or a global ....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage24,
  route: "automating-business-reporting-with-the-zynth-api",
},
{
  id: 25,
  date: "Sep 19,2025",
  readTime: "6 min read",
  title: "How Agencies Can Stay Ahead With AI-Powered Content & Design Tools",
  description:
    "The agency world has always been fast-paced. Whether it’s a marketing agency delivering monthly....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage25,
  route: "how-agencies-can-stay-ahead-with-ai-powered-content-and-design-tools",
},
{
  id: 26,
  date: "Oct 6,2025",
  readTime: "6 min read",
  title: "Data-Driven Storytelling: How AI Turns Numbers Into Compelling Visuals",
  description:
    "In business, data tells the truth—but storytelling makes people listen. Whether you’re a marketing....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage26,
  route: "data-driven-storytelling-how-ai-turns-numbers-into-compelling-visuals",
},
{
  id: 27,
  date: "Oct 8,2025",
  readTime: "6 min read",
  title: "Why Zynth Is More Than a Deck Builder: The Business Documentation Advantage",
  description:
    "In today’s fast-paced business world, presentations and documentation are the currency of....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage27,
  route: "why-zynth-is-more-than-a-deck-builder-the-business-documentation-advantage",
},
{
  id: 28,
  date: "Oct 10,2025",
  readTime: "6 min read",
  title: "Why Google Slides + Zynth Is a Game-Changer for Teams",
  description:
    "In the era of hybrid work, teams live inside collaborative platforms like Google Workspace,....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage28,
  route: "why-google-slides-zynth-is-a-game-changer-for-teams",
},
{
  id: 29,
  date: "Oct 13,2025",
  readTime: "6 min read",
  title: "For SaaS Companies: Embed AI-Powered Deck Creation Into Your Product",
  description:
    "Why Embed AI Presentation Tools in SaaS Platforms....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage29,
  route: "for-saas-companies-embed-ai-powered-deck-creation-into-your-product",
},
{
  id: 30,
  date: "Oct 14,2025",
  readTime: "6 min read",
  title: "The No-Code Future: Building Business Docs Without Designers or Developers",
  description:
    "In today’s fast-paced business world, speed and efficiency are everything. Organizations need....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage30,
  route: "the-no-code-future-building-business-docs-without-designers-or-developers",
},
{
  id: 31,
  date: "Oct 15,2025",
  readTime: "6 min read",
  title: "From Bullet Points to Visual Frameworks: The Evolution of Slide Design",
  description:
    "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage31,
  route: "from-bullet-points-to-visual-frameworks-the-evolution-of-slide-design",
},

  {
    id: 32,
    date: "Oct 16, 2025",
    readTime: "6 min read",
    title: "How We Blend Text Graphics to Create Engaging Presentations",
    description:
      "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage32,
    route: "how-we-blend-text-graphics-to-create-engaging-presentations",
  },
  {
    id: 33,
    date: "Oct 17, 2025",
    readTime: "6 min read",
    title: "Top Productivity Hacks Using Zynth's Google Slides Integration",
    description:
      "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage33,
    route: "top-productivity-hacks-using-zynths-google-slides-integration",
  },
  {
    id: 34,
    date: "Oct 20, 2025",
    readTime: "6 min read",
    title: "Introduction: Scaling Enterprise Workflows With Zynth's Presentation API",
    description:
      "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage34,
    route: "introduction-scaling-enterprise-workflows-with-zynths-presentation-api",
  },
  {
    id: 35,
    date: "Oct 21, 2025",
    readTime: "6 min read",
    title: "Introduction: Generative AI in Business - Moving Beyond Text to Visual Communication",
    description:
      "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage35,
    route: "introduction-generative-ai-in-business-moving-beyond-text-to-visual-communication",
  },
  {
    id: 36,
    date: "Oct 22, 2025",
    readTime: "6 min read",
    title: "Why Speed Matters: Saving Hours With AI Presentations",
    description:
      "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
    views: 180,
    comments: 1,
    imageUrl: Blogimage36,
    route: "why-speed-matters-saving-hours-with-ai-presentations",
  },

{
  id: 37,
  date: "Oct 23, 2025",
  readTime: "6 min read",
  title: "Zynth for Startups: How We’ve Helped 500+ Founders Build Investor Decks Instantly",
  description:
    "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage37,
  route: "zynth-for-startups-how-weve-helped-500-founders-build-investor-decks-instantly",
},
{
  id: 38,
  date: "Oct 25, 2025",
  readTime: "6 min read",
  title: "Free Credits for Early Add-On Users: How to Get Started Today",
  description:
    "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage38,
  route: "free-credits-for-early-add-on-users-how-to-get-started-today",
},
{
  id: 39,
  date: "Oct 27, 2025",
  readTime: "6 min read",
  title: "Case Study: Using the Zynth API to White-Label Investor Deck Builders",
  description:
    "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage39,
  route: "case-study-using-the-zynth-api-to-white-label-investor-deck-builders",
},
{
  id: 40,
  date: "Oct 29, 2025",
  readTime: "6 min read",
  title: "Infographics vs. Text Slides: Choosing the Right Format for Your Message",
  description:
    "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage40,
  route: "infographics-vs-text-slides-choosing-the-right-format-for-your-message",
},
{
  id: 41,
  date: "Oct 31, 2025",
  readTime: "6 min read",
  title: "Enterprise-Ready Presentations: White-Labeling Zynth for Your Business",
  description:
    "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage41,
  route: "enterprise-ready-presentations-white-labeling-zynth-for-your-business",
},
{
  id: 42,
  date: "Nov 02, 2025",
  readTime: "6 min read",
  title: "The Future of Business Documentation: APIs for Automated Presentations",
  description:
    "In the early days of presentations, slides were simple: black text on a white background, usually filled....",
  views: 180,
  comments: 1,
  imageUrl: Blogimage42,
  route: "the-future-of-business-documentation-apis-for-automated-presentations",
},





];

const BlogCard: React.FC<{ blog: Blog }> = ({ blog }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/${blog.route}`);
  };
  return (
    <div className="group flex lg:flex-row flex-col gap-6 mt-20 bg-white rounded-lg border border-white shadow-md">
      <img
        onClick={handleClick}
        src={blog.imageUrl}
        alt={blog.title}
        className="lg:w-1/2 h-1/2 object-cover rounded-lg"
      />
      <div className="flex-1 p-6 group-hover:text-[#A67A4B]">
        <p className="text-sm text-gray-500 mb-2 group-hover:text-[#A67A4B]">
          {blog.date} • {blog.readTime}
        </p>
        <h3
          onClick={handleClick}
          className="text-2xl font-semibold mb-4 group-hover:text-[#A67A4B]"
        >
          {blog.title}
        </h3>
        <p className="text-base text-gray-700 mb-6 group-hover:text-[#A67A4B]">
          {blog.description}
        </p>
        {/* <p className="text-sm text-gray-500 ">
          {blog.views} views • {blog.comments} comments
        </p> */}
      </div>
    </div>
  );
};
const BlogList: React.FC = () => {
  
  const sortedBlogData = useMemo(() => {
    const parseDate = (dateString: string): Date => {
      const [monthDay, year] = dateString.split(",");
      const [month, day] = monthDay.trim().split(" ");

      const monthMap: { [key: string]: number } = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };

      return new Date(parseInt(year), monthMap[month], parseInt(day));
    };

    return [...blogData].sort((a, b) => {
      const dateA = parseDate(a.date);
      const dateB = parseDate(b.date);
      return dateB.getTime() - dateA.getTime();
    });
  }, []);

  return (
    <div>
      <div className="max-w-5xl mx-auto px-4 py-10 ">
        {sortedBlogData.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>
      {/* Footer Section */}
      <footer className="bg-white py-12 mt-10">
        <div className="container mx-auto px-4">
          {/* Footer Logo & Text */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
            <div className="text-left mb-6 md:mb-0">
              <img
                src={zynthtext}
                alt="Zynth Logo"
                className="h-10 mb-4 md:mb-2 mx-auto md:mx-0"
              />
              <p className="text-black text-sm">
                Create your investor presentations in a few minutes using our
                AI-powered pitch deck builder. No design skills needed.
              </p>
              <p className="text-black text-sm mt-2">
                © 2024 Parati Technologies Private Limited. All rights reserved.
              </p>
            </div>
          </div>
          {/* Footer Links */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-left">
            <div>
              <h3 className="font-bold text-gray-800 mb-4">Company</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://www.parati.in/about-us"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:underline"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.parati.in/impactdb"
                    target="_blank"
                    className="text-gray-600 hover:underline"
                  >
                    Impact DB
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.parati.in/eos"
                    target="_blank"
                    className="text-gray-600 hover:underline"
                  >
                    Parati Eos
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-gray-800 mb-4">Services</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://www.parati.in/business-strategy"
                    target="_blank"
                    className="text-gray-600 hover:underline"
                  >
                    Business Strategy
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.parati.in/investor-relations"
                    target="_blank"
                    className="text-gray-600 hover:underline"
                  >
                    Investor Relations
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.parati.in/managed-operations"
                    target="_blank"
                    className="text-gray-600 hover:underline"
                  >
                    Managed Operations
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.parati.in/digital-transformation"
                    target="_blank"
                    className="text-gray-600 hover:underline"
                  >
                    Digital Transformation
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-gray-800 mb-4">Helpful Links</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://zynth.ai/about"
                    target="_blank"
                    className="text-gray-600 hover:underline"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    href="https://zynth.ai/contact"
                    className="text-gray-600 hover:underline"
                    target="_blank"
                  >
                    Contact us
                  </a>
                </li>
                <li></li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-gray-800 mb-4">Legal</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://zynth.ai/uploads/privacy"
                    className="text-gray-600 hover:underline"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="https://zynth.ai/uploads/refunds"
                    className="text-gray-600 hover:underline"
                    target="_blank"
                  >
                    Refunds and Cancellations
                  </a>
                </li>
                <li>
                  <a
                    href="https://zynth.ai/uploads/terms"
                    className="text-gray-600 hover:underline"
                    target="_blank"
                  >
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default BlogList;
